import tippy from "tippy.js";
import Accordions from "a11y-accordion-component";
import { breakpoints } from "../../variables.json";

const options = {
	theme: "submenu",
	trigger: "mouseenter focus",
	appendTo: "parent",
	placement: "bottom",
	maxWidth: "100%",
	role: "dropdown",
	interactive: true,
	animateFill: false,
	aria: {
		content: null,
		expanded: false,
	},
	zIndex: 11,
	offset: [0, 0],
	allowHTML: true,
	arrow: false,
	onMount({ reference }) {
		reference.setAttribute("aria-expanded", "true");
		document.documentElement.classList.add("fade");
	},
	onHide({ reference }) {
		reference.setAttribute("aria-expanded", "false");
		document.documentElement.classList.remove("fade");
	},
	onShow(instance) {
		const lazyImgs = instance.popper.querySelectorAll('img.lazy');
		[...lazyImgs].forEach(lazyImg => {
			lazyImg.src = lazyImg.dataset.src;
		});
	},
};

tippy('[data-nav-trigger1]', {
		...options,
		content: (reference) => document.getElementById(reference.getAttribute("data-nav-trigger1")).innerHTML,
		popperOptions: {
			modifiers: [{
				name: 'overrideStyle',
				enabled: true,
				phase: "beforeWrite",
				requires: ["computeStyles"],
				fn({ state }) {
					state.styles.popper.top = `100%`;
					state.styles.popper.left = 0;
					state.styles.popper.right = 0;
					state.styles.popper.maxWidth = "100%";
					state.styles.popper.transform = "";
				},
				effect: ({ state }) => {
					state.elements.popper.style.top = `100%`;
					state.elements.popper.style.left = 0;
					state.elements.popper.style.right = 0;
					state.elements.popper.style.maxWidth = "100%";
					state.elements.popper.style.transform = "";
				}
			}],
		}
	}
);


tippy("[data-nav-trigger2]", {
	...options,
	content: (reference) => document.getElementById(reference.getAttribute("data-nav-trigger2")).innerHTML,
	popperOptions: {
		modifiers: [{
			name: 'overrideStyle2',
			enabled: true,
			phase: "beforeWrite",
			requires: ["computeStyles"],
			fn({ state }) {
				if (matchMedia(`(min-width:${breakpoints.medium})`).matches) {
					state.styles.popper.left = "auto";
				} else {
					state.styles.popper.left = 0;
				}
				state.styles.popper.top = `100%`;
				state.styles.popper.right = 0;
				state.styles.popper.maxWidth = "100%";
				state.styles.popper.transform = "";
			},
			effect: ({ state }) => {
				if (matchMedia(`(min-width:${breakpoints.medium})`).matches) {
					state.elements.popper.style.left = "auto";
				} else {
					state.elements.popper.style.left = 0;
				}
				state.elements.popper.style.top = `100%`;
				state.elements.popper.style.right = 0;
				state.elements.popper.style.maxWidth = "100%";
				state.elements.popper.style.transform = "";
				}
		}]
	}
});

tippy("[data-nav-trigger3]", {
	...options,
	content(reference) {
		const hiddenItems = reference.parentNode.querySelectorAll("[data-hidden]");
		const html = [...hiddenItems].map(item => item.outerHTML);
		return html.join("").replace(/data-hidden/g, "data-visible");
	},
	popperOptions: {
		modifiers: [{
			name: 'overrideStyle3',
			enabled: true,
			phase: "beforeWrite",
			requires: ["computeStyles"],
			fn({ state }) {
				if (matchMedia(`(min-width:${breakpoints.medium})`).matches) {
					state.styles.popper.top = "24px";
					state.styles.popper.left = "60px";
					state.styles.popper.width = "100%";
					state.styles.popper.maxWidth = "225px";
				} else {
					state.styles.popper.top = "100%";
					state.styles.popper.left = 0;
					state.styles.popper.right = 0;
					state.styles.popper.transform = "";
					state.styles.popper.maxWidth = "100%";
				}
				return data;
			},
			effect: ({ state }) => {
				if (matchMedia(`(min-width:${breakpoints.medium})`).matches) {
					state.elements.popper.style.left = "auto";
				} else {
					state.elements.popper.style.left = 0;
				}
				state.elements.popper.style.top = `100%`;
				state.elements.popper.style.right = 0;
				state.elements.popper.style.maxWidth = "100%";
				state.elements.popper.style.transform = "";
			}
		}]
	}
});

tippy("[data-nav-hover]", {
	...options,
	placement: "bottom-start",
	trigger: "mouseenter focus",
	delay: [0, 0],
	onMount(instance) {
		instance.reference.setAttribute("aria-expanded", "true");
	},
	onHide(instance) {
		instance.reference.setAttribute("aria-expanded", "false");
	},
	onShow(instance) {
		const lazyImgs = instance.popper.querySelectorAll('img.lazy');
		[...lazyImgs].forEach(lazyImg => {
			lazyImg.src = lazyImg.dataset.src;
		});
	},
	content(reference) {
		const id = reference.getAttribute("data-nav-hover");
		return document.getElementById(id).innerHTML;
	},
	popperOptions: {
		modifiers: [{
			name: 'overrideStylesNav',
			enabled: true,
			phase: "beforeWrite",
			requires: ["computeStyles"],
			fn({ state }) {
				if (matchMedia(`(min-width:${breakpoints.content})`).matches) {
					state.styles.popper.top = 0;
					state.styles.popper.left = "-30px";
					state.styles.popper.right = "auto";
					state.styles.popper.maxWidth = "calc(100% + 320px)";
					state.styles.popper.width = "320px";
				} else {
					state.styles.popper.display = "none";
				}
			},
			effect: ({ state }) => {
				if (matchMedia(`(min-width:${breakpoints.content})`).matches) {
					state.elements.popper.style.top = 0;
					state.elements.popper.style.left = "-30px";
					state.elements.popper.style.right = "auto";
					state.elements.popper.style.maxWidth = "calc(100% + 320px)";
					state.elements.popper.style.width = "320px";
				} else {
					state.elements.popper.style.display = "none";
				}
			}
		}]
	}
});

tippy("[data-megamenu-hover]", {
	theme: "blank",
	trigger: "mouseenter focus",
	placement: "bottom",
	maxWidth: "100%",
	interactive: true,
	animateFill: false,
	delay: [0, 250],
	zIndex: 11,
	offset: [0, 0],
	aria: {
		content: null,
		expanded: false,
	},
	arrow: false,
	role: 'tooltip',
	appendTo: () => document.body,
	onMount(instance) {
		instance.reference.setAttribute("aria-expanded", "true");
		document.documentElement.classList.add("fade");
		Accordions.render("megamenu-menu", {
			isCollapsible: false,
			isMultiSelectable: false
		});
	},
	onShow(instance) {
		const lazyImgs = instance.popper.querySelectorAll('img.lazy');
		[...lazyImgs].forEach(lazyImg => {
			lazyImg.src = lazyImg.dataset.src;
		});
	},
	onHide(instance) {
		instance.reference.setAttribute("aria-expanded", "false");
		document.documentElement.classList.remove("fade");
	},
	content(reference) {
		const megamenu = document.querySelector(".js-megamenu").cloneNode(true);
		megamenu.querySelector(".js-megamenu-menu").id = "megamenu-menu";
		const triggers = megamenu.querySelectorAll("[data-controls]");
		[...triggers].forEach(trigger => {
			const hash = Date.now().toString(16);
			const panel = megamenu.querySelector("#" + trigger.dataset.controls);
			if (panel) panel.id += hash;
			trigger.id += hash;
			trigger.dataset.controls += hash;
		});
		// megamenu.classList.add("tippy-popper");
		return megamenu;
	},
	allowHTML: true,
	popperOptions: {
		modifiers: [{
			name: 'overrideStyleMegaMenu',
			enabled: true,
			phase: "beforeWrite",
			requires: ["computeStyles"],
			fn({ state }) {
				state.styles.popper.top = `90px`;
				state.styles.popper.left = 0;
				state.styles.popper.right = 0;
				state.styles.popper.maxWidth = "100%";
				state.styles.popper.transform = "";
			},
			effect: ({ state }) => {
				state.elements.popper.style.top = `90px`;
				state.elements.popper.style.left = 0;
				state.elements.popper.style.right = 0;
				state.elements.popper.style.maxWidth = "100%";
				state.elements.popper.style.transform = "";
			}
		}],
	}
});

const header = document.querySelector(".js-header");
const navigationL2 = header.querySelector(".js-navigation-l2");

if (navigationL2) {
	window.addEventListener("scroll", stickyHeaderHandler, false);
}


function stickyHeaderHandler() {
	const offset = header.clientHeight;
	if (window.scrollY >= offset) {
		header.classList.add("site-header--stuck");
	} else {
		header.classList.remove("site-header--stuck");
	}
}
